import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import styles from './Login.module.css';

export const LinkedInCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithLinkedInCallback } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [processing, setProcessing] = useState(true);

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const storedState = sessionStorage.getItem('linkedin_oauth_state');
    const errorParam = searchParams.get('error');

    if (errorParam) {
      navigate('/login');
      return;
    }

    if (!code) {
      navigate('/login');
      return;
    }

    // CSRF check
    if (state !== storedState) {
      setError('Beveiligingsvalidatie mislukt. Probeer het opnieuw.');
      setProcessing(false);
      setTimeout(() => navigate('/login'), 3000);
      return;
    }

    sessionStorage.removeItem('linkedin_oauth_state');

    const exchangeCode = async () => {
      const result = await loginWithLinkedInCallback(code, state || '');

      if (result.success) {
        navigate('/projects');
      } else {
        setError(result.error || 'LinkedIn login mislukt');
        setProcessing(false);
        setTimeout(() => navigate('/login'), 3000);
      }
    };

    exchangeCode();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={styles.loginScreen}>
      <div className={styles.loginContent}>
        <div className={styles.loginBox}>
          {error ? (
            <p style={{ color: '#1E3A2F', textAlign: 'center' }}>{error}</p>
          ) : processing ? (
            <p style={{ textAlign: 'center', color: '#323232' }}>Bezig met inloggen via LinkedIn...</p>
          ) : null}
        </div>
      </div>
    </div>
  );
};
